export const GET_ARTICLES = "admin/article/getArticles";

export const DELETE_ARTICLE = "admin/article/articleDelete";

export const ARTICLE_ACTION = "admin/article/articleDisable";

export const POST_ARTICLE = "admin/article/post";

export const EDIT_ARTICLE = "admin/article/editArticle";
